import React from 'react';
import './index.less'
class SuspensionInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
            value: '',
            isLabelTop: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({
            value: event.target.value
        });
    }
    handleFocus() {
        this.setState({
            isLabelTop: true
        });
    }

    handleBlur() {
        this.setState({
            isLabelTop: false
        });
    }
    render() {
        let {isLabelTop, label, value, type} = this.state;
        return (
            <div className="SuspensionInput">
                <span className="SuspensionInput-ber" style={{width: isLabelTop ? '100%' : '0'}}>
                </span>
                <span className="SuspensionInput-label"
                      style={{bottom: !!value || isLabelTop ? '1.6em' : '',   transform: `scale(${ !!value || isLabelTop ? '.9' : '1'})translateX(${ !!value ||isLabelTop ? '-1px' : '0'})`}}>
                    {label || '用户'}</span>
                <input onChange={this.handleChange}
                       type={type || 'text'}
                       onFocus={this.handleFocus.bind(this)}
                       onBlur={this.handleBlur.bind(this)}
                       onInput={e => this.props.change(e.target.value)}
                       placeholder={''}/>
            </div>
        );
    }
}
export default  SuspensionInput;
